/* eslint-disable no-bitwise */
export function textEllipsis(line: string) {
  return (
    `display: block;
  display: -webkit-box;
  -webkit-line-clamp: ${line};
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;`
  );
}

export function circle(size: string) {
  return (`
    display: inline-flex;
    width: ${size};
    height: ${size};
    border-radius: 50%;
  `);
}

export function percentage(size: string, col: number) {
  return (`
    width: calc((${size} * 12) / ${col});
  `);
}

export function scrollbarVertical(width: string, color: string, bg: string) {
  return (`
    &::-webkit-scrollbar-track{
      border-radius: calc(${width} / 2);
      background-color: ${bg};
    }

    &::-webkit-scrollbar{
      width: ${width};
      background-color: ${bg};
    }

    &::-webkit-scrollbar-thumb{
      border-radius: calc(${width} / 2);
      background-color: ${color};
    }
  `);
}

export function colorLighten(color: string, amount: number) {
  const inputColor = color;
  const lighten = `#${inputColor.replace(/^#/, '').replace(/../g, cor => (`0${Math.min(255, Math.max(0, parseInt(cor, 16) + amount)).toString(16)}`).substr(-2))}`;
  return lighten;
}

export function scrollStyle() {
  return `
    ::-webkit-scrollbar {
      width: 10px;
      height: 10px;
      background-color: transparent;
      border-radius: 0 10px 10px 0;
    }

    ::-webkit-scrollbar-thumb {
      background-color: #7e7e7e47;
      border-radius: 10px;
      height: 10px;
    }
  `;
}

export function boxShadow() {
  return `
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.04);
  `;
}